import { __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import { SolutionGridWrapper } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { getSolutionsBaseBySlugs } from '../../../api/api';
import { SearchResultHeader } from '../search-result-header';
import { WithFetcher, } from '../../../component-decorators/with-fetcher';
import s from '../search-result/search-result.scss';
import { CenteredLoader } from '../../centered-loader';
import { Box } from 'wix-style-react';
import { FluidContainer } from '../../FluidContainer';
import { useConfigContext } from '../../../config-context';
var SearchResultEmptyState = /** @class */ (function (_super) {
    __extends(SearchResultEmptyState, _super);
    function SearchResultEmptyState(props) {
        return _super.call(this, props) || this;
    }
    SearchResultEmptyState.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.props.query !== prevProps.query) {
                    this.props.reFetch(function () {
                        return getSolutionsBaseBySlugs(['staff-picks'], _this.props.locale, _this.props.countryCode, true, true);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    SearchResultEmptyState.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { backgroundColor: '#f0f4f7', height: '132px' }),
            React.createElement(FluidContainer, { className: s.pageSettings, dataHook: 'search-result-empty-state' },
                React.createElement(SearchResultHeader, { isResult: false, query: this.props.query }),
                React.createElement(SolutionGridWrapper, { solutions: this.props.fetchData.suggestions, referralSectionName: "empty-search" }))));
    };
    return SearchResultEmptyState;
}(React.Component));
export var SearchResultEmptyStateFetcher = function (_a) {
    var query = _a.query, experiments = _a.experiments;
    var _b = useConfigContext(), locale = _b.locale, countryCode = _b.countryCode;
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: function () {
            return getSolutionsBaseBySlugs(['staff-picks'], locale, countryCode, true, true);
        }, fetchMemoizationId: "search-result-empty-state-" + query + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        return (React.createElement(SearchResultEmptyState, { fetchData: fetchData, reFetch: reFetch, query: query, locale: locale, countryCode: countryCode }));
    }));
};
//# sourceMappingURL=search-result-empty-state.js.map